export {default} from './FullName.connect';
